// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__RdBMd","active":"Dashboard_active__XFVXL"};